<template>
  <svg class="iconfont-symbol" :style="svgStyle" aria-hidden="true" v-bind="$attrs" v-on="$listeners">
    <use :xlink:href="symbolId"></use>
  </svg>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    icon: { type: String, required: true },
    width: { type: [String, Number], default: 24 },
    height: { type: [String, Number], default: 24 },
    color: { type: String, default: null }
  },
  computed: {
    symbolId() {
      if (this.icon.indexOf("#") === 0) return this.icon
      if (this.icon.indexOf("icon-") === 0) return `#${this.icon}`
      return `#icon-${this.icon}`
    },
    svgStyle() {
      return {
        width: this.formatSize(this.width),
        height: this.formatSize(this.height),
        color: this.color || undefined
      }
    }
  },
  methods: {
    formatSize(size) {
      if (typeof size === "number") return `${size}px`
      if (/^\d+(\.\d+)?$/.test(size)) return `${size}px`
      return size
    }
  }
}
</script>

<style scoped>
.iconfont-symbol {
  display: inline-block;
  vertical-align: -0.15em;
  overflow: hidden;
  fill: currentColor;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/assets/fonts/IconFont.vue